import React, {useEffect, useState} from "react";

import PropTypes from 'prop-types';
import {FieldTable } from "../../../components/FieldTable/FieldTable";
import { variableCurrencyValue } from '../../../components/field-table';
import {CostSupplierSelect} from "../../../components/MaterialSelects/CostSupplierSelect";
import {FieldTableColumnProps} from "../../../components/FieldTable/FieldTableTypes";
import {Cost, useGetCampaignCostPaneQueryQuery} from "../../../generated/graphql";
import { useOutletContext } from "react-router-dom";
import {CampaignOutletContextValue} from "../form";

const newRow = () => ({
  campaignComponent: {
    unit_value_local: 0, qty: 1
  },
  supplier_code: '',
  invoice_number: ''
});

const columns:FieldTableColumnProps<Cost>[] = [
  {
    header: 'Supplier',
    accessor: 'costSupplier',
    sort: 'costSupplier.label',
    dataType:'select',
    options: {
      label:'label',
      renderEditor: ({ field }) => {
        return <CostSupplierSelect {...field} />;
      }
    }
  },
  {
    header: 'Supplier Code',
    accessor: 'costSupplier.code',
    dataType:'text'
  },
  {
    header: 'Supplier Cat',
    accessor: 'costSupplier.costSupplierCategory.label',
    sort: 'costSupplier.costSupplierCategory.label',
    dataType:'default'
  }, {
    header: 'Invoice Number',
    accessor: 'invoice_number',
    className: 'column-width-wide',
    dataType:'text'
    // eslint-disable-next-line react/prop-types, react/display-name
  },{
    header: 'Unit Price',
    accessor: 'campaignComponent.unit_value_local',
    dataType: 'currency',
    //currencyAccessor: 'campaignComponent.currency',
    options: {
      currency: {
        accessor: 'campaignComponent.currency',
        allowContextCurrency:true
      }
    },
    // eslint-disable-next-line react/prop-types, react/display-name
    summaries: {
      // eslint-disable-next-line react/prop-types, react/display-name
      footer: () => {
        return <b style={{display:'flex',alignItems:'center'}}>Total</b>
      }
    }
  },{
    header: 'Qty',
    accessor: 'campaignComponent.qty',
    dataType:'number',
    summaries: {
      footer: ({ rows }) => {
        return rows.reduce((total, current) => { return total + (parseInt(current.campaignComponent?.qty) || 0); }, 0)
      }
    }
  },
  {
    header: 'Total',
    accessor: 'total',
    dataType:'currency',
    readOnly: true,
    options: {
      currency: {
        accessor: 'campaignComponent.currency',
      },
      getValue: ({field, row}) => {
        return row.campaignComponent?.qty * row.campaignComponent?.unit_value_local;
      }
    },
    summaries: {
      footer: ({ rows, currency }) => {
        // if multiple currencies, do NOT sum here...
        const defaultCurrency = currency?.id;
        let seenOther = false;
        const value = rows.reduce((total, current) => {
          const cid = current.campaignComponent?.currency?.id;
          if (cid && defaultCurrency != cid) {
            seenOther = true;
          }
          return (total + (parseInt(current.campaignComponent?.qty) * parseInt(current.campaignComponent?.unit_value_local)));
        }, 0);
        if(seenOther) return null;
        return variableCurrencyValue({ currency: currency, value: value });
      }
    }
  }, {
    header: 'Total Quote',
    accessor: 'total_quote',
    dataType:'currency',
    readOnly: true,
    hideWhen:({exchangeRateContext})=>{
      if(exchangeRateContext.options && exchangeRateContext.options.length>1) return false;
      return true;
    },
  //  currencyAccessor: 'campaignComponent.currency',
    // eslint-disable-next-line react/prop-types, react/display-name
    options: {
      getValue: ({field, row, calcExchangeRate}) => {
        if (!field) return null;
        return variableCurrencyValue({
          currency: field.currency,
          value: calcExchangeRate(row.campaignComponent?.currency, row.campaignComponent?.qty * row.campaignComponent?.unit_value_local),
          places:0
        });
      }
    },
    summaries: {
      footer: ({ rows, currency, calcExchangeRate }) => {
        const value = rows.reduce((total, current) => { return (total + calcExchangeRate(current.campaignComponent?.currency,(parseInt(current.campaignComponent?.qty) * parseInt(current.campaignComponent?.unit_value_local)))); }, 0)
        return variableCurrencyValue({ currency: currency, value: value });
      }
    }
  }
];


const summaries = {
  footer: (old, newRow) => { return !newRow; }
}

const CostsPane = () => {
  const { values, setValue, loading, jobRef, errors, readOnly,setTab } = useOutletContext<CampaignOutletContextValue>();
  const [doneRender, setDoneRender] = useState(false);
  useEffect(()=>{
    setTab('costs');
  },[]);

  // const {refetch, data } = useGetCampaignCostPaneQueryQuery({
  //   variables: { ref: jobRef },
  //   skip: true,
  //   fetchPolicy: 'network-only',
  //   onCompleted: (data) => {
  //     if(data.campaign?.costs){
  //       console.log("I AM HITTT AGAIN 3", readOnly)
  //     }
  //   }
  // });
  // useEffect(() => {
  //   console.log("I AM HITTT 22", doneRender, loading, jobRef)
  //   if (doneRender && !loading && jobRef) {
  //     refetch({ ref: jobRef });
  //     setDoneRender(false);
  //   }
  // }, [doneRender, loading, jobRef]);  

  return (<FieldTable
    columns={columns}
    newRow={newRow}
    newRowLabel="Add Cost"
    setValue={setValue}
    values={values.costs}
    readOnly={readOnly}
    name="costs"
    errors={errors}
    loading={loading}
    summaries={summaries}
  />);
}


export default CostsPane;
